import { useEffect } from "react";

/** Decoration only: content remains readable without JavaScript or motion support. */
export function usePageMotion(view: string) {
  useEffect(() => {
    const preference = window.matchMedia("(prefers-reduced-motion: reduce)");
    let observer: IntersectionObserver | undefined;
    const targets = document.querySelectorAll<HTMLElement>(
      "main .trust-strip > button, main .section-heading, main .community-banner, main .page-heading, main .community-empty",
    );
    const start = () => {
      observer?.disconnect();
      targets.forEach((element) => element.classList.remove("gruvo-revealed"));
      if (preference.matches || !("IntersectionObserver" in window)) return;
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("gruvo-revealed");
          observer?.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
      targets.forEach((element) => observer?.observe(element));
    };
    start();
    preference.addEventListener("change", start);
    return () => {
      observer?.disconnect();
      preference.removeEventListener("change", start);
      targets.forEach((element) => element.classList.remove("gruvo-revealed"));
    };
  }, [view]);
}
